@if (!showPage && !loading) {
  <scitis-empty-state-fallback [fallBackMessage]="fallBackMessage">
  </scitis-empty-state-fallback>
}

@if (showPage) {
  <div class="row mb-4 justify-content-between">
    <div class="col-auto d-flex align-items-center mb-2 mb-md-0">
      @if (displayBackButton) {
        <button (click)="levelUp()" class="btn btn-primary mr-3">
          <span class="fa-solid fa-chevron-left mr-2"></span>
          <span translate>Back</span>
        </button>
      }
      @if (!searchMode) {
        <h4 class="h5 mb-0" [innerText]="currentLevel"></h4>
      }
    </div>
  </div>
}

<!-- Grid View -->
@if (showPage && tileMode) {
  <div class="grid-groups mb-3">
    @for (folder of folders; track folder) {
      <div class="group-tile" (click)="openFolder(folder)">
        <div class="group-info">
          <span class="group-info-icon">
            <i class="fa-solid fa-folder"></i>
          </span>
          <div class="group-info-title">
            <strong class="title" [innerText]="folder.name"></strong>
            <span class="data">
              <span class="data-item" [innerText]="getFilesNumber(folder.count)"></span>
            </span>
          </div>
        </div>
      </div>
    }
  </div>
}

<!-- List View -->
@if (showPage && listMode) {
  <div class="row">
    <div class="col-12">
      <div class="list-group mb-3">
        @for (folder of folders; track folder) {
          <a
            class="list-group-item list-group-item-action d-flex justify-content-between"
            (click)="openFolder(folder)">
            <span class="list-group-item-title">
              <span class="fa-solid fa-folder mr-2"></span>
              <span [innerText]="folder.name"></span>
            </span>
            <div class="list-group-item-more">
              @if (displayBadge(folder.count)) {
                <span class="badge badge-primary badge-pill"
                [innerText]="folder.count"></span>
              }
              <span class="fa-solid fa-chevron-right ml-2"></span>
            </div>
          </a>
        }
      </div>
    </div>
  </div>
}

@for (file of files; track file) {
  <div (click)="select(file)" class="group-tile">
    <span [innerText]="file.name"></span>
  </div>
}

